import React from 'react'
import { Button, Flex, Text } from 'pcln-design-system'
import useExpressDealModal from '@/hooks/useExpressDealModal'
import ExpressDealModal from './ExpressDealModal'

export default function ExpressDealBanner() {
  const { isOpen, openModal } = useExpressDealModal()

  return (
    <Button
      color="background.light"
      onClick={openModal}
      p={3}
      tabIndex={0}
      width={1}
    >
      <Flex
        color="background.light"
        justifyContent="center"
        flexWrap="wrap"
        alignItems="center"
      >
        <Text fontSize={1} textAlign="center" color="text.dark">
          Want even bigger discounts? Save up to 50% by
        </Text>
        <Text fontSize={1} color="primary" pl={1}>
          searching Express Deals
        </Text>
        <Text fontSize={1} textAlign="center" color="text.dark">
          .
        </Text>
      </Flex>
      <ExpressDealModal isModalOpen={isOpen} />
    </Button>
  )
}
